import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineEventBusy, MdOutlineMoreTime } from "react-icons/md";
import LeaveRequests from "./LeaveRequests";
import PermissionRequests from "./PermissionRequests";

const TABS = [
    { key: "leave", name: "Leave", icon: <MdOutlineEventBusy />, Component: LeaveRequests },
    { key: "permission", name: "Permission", icon: <MdOutlineMoreTime />, Component: PermissionRequests },
];

const TimeOff = () => {
    // The tab lives in the URL (?tab=permission) with its list's page and filters, so Back returns to it.
    const location = useLocation();
    const navigate = useNavigate();
    const wanted = new URLSearchParams(location.search).get("tab");
    const activeTab = TABS.some((tab) => tab.key === wanted) ? wanted : TABS[0].key;
    // A new tab starts on its first page with no filters.
    const setActiveTab = (key) => {
        if (key === activeTab) return;
        navigate({ pathname: location.pathname.replace(/\/page\/\d+\/?$/, ""), search: key === TABS[0].key ? "" : `?tab=${key}` });
    };
    const ActiveComponent = TABS.find((tab) => tab.key === activeTab)?.Component || TABS[0].Component;

    return (
        <div className="timeoff-page">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                <div>
                    <h4 className="fw-semibold mb-1">Leave / Permission</h4>
                    <p className="text-muted mb-0">Approve or reject the leave and permission requests staff have raised.</p>
                </div>
            </div>

            <div className="att-tabs" role="tablist">
                {TABS.map((tab) => (
                    <button
                        key={tab.key}
                        type="button"
                        role="tab"
                        aria-selected={activeTab === tab.key}
                        className={`att-tab-btn ${activeTab === tab.key ? "active" : ""}`}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        <span className="att-tab-icon">{tab.icon}</span>
                        {tab.name}
                    </button>
                ))}
            </div>

            <ActiveComponent />
        </div>
    );
};

export default TimeOff;
